import React from 'react';

const FileUploadSection = ({ 
  title, 
  field, 
  description, 
  format, 
  required = false,
  courseData,
  onThumbnailChange,
  showToast
}) => {
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      onThumbnailChange(file, previewUrl);
      showToast('Thumbnail image uploaded successfully!', 'success');
    }
  };

  const handleDeleteThumbnail = () => {
    onThumbnailChange(null, null);
    showToast('Thumbnail removed', 'info');
  };

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-3">
        {title} {required && '*'}
      </label>
      <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center transition-all duration-300 hover:border-green-400 hover:bg-green-50">
        <div className="max-w-xs mx-auto">
          {courseData.thumbnail ? (
            <div className="relative w-32 h-32 mx-auto mb-4 rounded-lg overflow-hidden border border-gray-200 group">
              <img 
                src={courseData.thumbnail} 
                alt="Course thumbnail" 
                className="w-full h-full object-cover"
              />
              <button
                type="button"
                onClick={handleDeleteThumbnail}
                className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-red-600 hover:scale-110"
                title="Delete thumbnail"
              >
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          ) : (
            <div className="relative w-32 h-32 mx-auto mb-4 rounded-lg overflow-hidden border-2 border-dashed border-gray-300 bg-gray-50 group flex items-center justify-center">
              <div className="text-center p-2">
                <svg className="w-8 h-8 text-gray-400 mx-auto mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <p className="text-xs text-gray-500 font-medium">No thumbnail added yet</p>
              </div>
            </div>
          )}
          <p className="text-gray-600 mb-2">{description}</p>
          <p className="text-sm text-gray-500 mb-4">{format}</p>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            className="hidden"
            id={`${field}-upload`}
          />
          <label
            htmlFor={`${field}-upload`}
            className="px-6 py-3 bg-green-500 text-white rounded-xl font-semibold cursor-pointer transition-all duration-300 hover:bg-green-600 hover:scale-105 inline-block"
          >
            {courseData.thumbnail ? 'Change Image' : `Choose ${field === 'thumbnail' ? 'Image' : 'Video'}`}
          </label>
          
          {courseData.thumbnail && (
            <button
              type="button"
              onClick={handleDeleteThumbnail}
              className="mt-3 px-4 py-2 text-red-500 border border-red-300 rounded-xl hover:bg-red-50 transition-all duration-300 flex items-center space-x-2 mx-auto"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              <span>Delete Thumbnail</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileUploadSection;